import { logger as log } from '@common/logger';
import { vappContainer } from '@/application';
import { SignInPageService } from '@/pages/SignIn';
import { StorageModule } from '@vlinder-web/storage-module-react';

import toast from 'react-hot-toast';
import { AppNavigatorService } from '@/AppNavigator';
const MODULE_NAME = 'profile.machines.states.signInUser';

const getSrv = () => {
  return vappContainer.get<SignInPageService>(SignInPageService.displayName);
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const validateOTP = async (context: any, event: any) => {
  const currentState = 'VALIDATE_OTP';
  const method = 'validateOTP';
  const storageSrv = StorageModule.getInstance();

  return new Promise(async (resolve, reject) => {
    try {
      console.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.verifyOTP(event?.payload);
      console.log(`validateEmail service content:`, content);
      if (content) {
        const passwordRecentlyUpdated =
          context?.PASSWORD_RECENTLY_UPDATED ?? false;
        if (passwordRecentlyUpdated) {
          console.log(`validateEmail response:`, content);
          resolve({
            type: 'RENDER_ACCOUNT_SELECTION',
            PASSWORD_RECENTLY_UPDATED: passwordRecentlyUpdated,
            value: content,
          });
        } else {
          console.log(`validateEmail response:`, content);
          resolve({
            type: 'CHANGE_PASSWORD',
            PASSWORD_RECENTLY_UPDATED: passwordRecentlyUpdated,
            value: content,
          });
        }
      } else {
        const msg = content?.error || 'OTP validation failed';
        toast.error(msg);
        return Promise.reject({
          type: 'VALIDATE_OTP_FAILED',
          value: content,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'VALIDATE_OTP_FAILED',
        value: 'Something went wrong please try again!',
      });
    }
  });
};
